import React from 'react';
import { CategoryHero } from 'shared/CategoryHero';
import { CategoryPage } from 'shared/CategoryPage';
import { Locations } from 'shared/Locations';
import { HomeSchedule } from 'views/Home/HomeSchedule';
import { Banner } from 'components/Banner';
import withScrollToTop from 'hocs/withScrollToTop';
import { useQuery } from '@apollo/client';
import { GET_CATEGORY_CD_PAGE } from 'services/graphql/pages/category';
import { GET_FILTERED_RECORDS } from 'services/graphql/records';
const CategoryCD = () => {
  const { loading, error, data } = useQuery(GET_CATEGORY_CD_PAGE);
  const {
    loading: loadingRecords,
    error: errorRecords,
    data: dataRecords,
  } = useQuery(GET_FILTERED_RECORDS, {
    variables: { activeCategory: 'C - D' },
  });
  return (
    <main className="category category-cd">
      <CategoryHero
        category="C_D"
        isLoading={loading}
        formTitle={
          <p>
            Переобучение <br /> с категории С на D
          </p>
        }
        blockColor="green"
        image={
          !loading && !error
            ? data?.categoryCdPage?.data?.attributes?.content.image
            : null
        }
        image_mobile={
          !loading && !error
            ? data?.categoryCdPage?.data?.attributes?.content.image_mobile
            : null
        }
        onAsyncFunc={() => setTimeout(() => alert('Success'), 200)}
      />
      <CategoryPage
        content={
          !loading && !error
            ? data?.categoryCdPage?.data?.attributes?.content
            : {}
        }
      />
      <HomeSchedule
        items={
          !loadingRecords && !errorRecords ? dataRecords?.records?.data : []
        }
      />
      {data?.categoryCdPage?.data?.attributes?.banner !== null && (
        <div className="container banner__container">
          <Banner content={data?.categoryCdPage?.data?.attributes?.banner} />
        </div>
      )}
      <Locations />
    </main>
  );
};

export default withScrollToTop(CategoryCD);
